import axios from "axios";

const { REACT_APP_FLASK_API_URL } = process.env;

/**
 * List premium backlinks with optional filters
 * @param {Object} params - Query parameters
 * @param {string} [params.added] - Filter by added date (ISO format)
 * @param {string} [params.client_domain] - Filter by client domain
 * @param {string} [params.domain] - Filter by domain
 * @param {number} [params.dr] - Filter by domain rating
 * @param {string} [params.id] - Filter by UUID
 * @param {number} [params.markup_percentage] - Filter by markup percentage
 * @param {string} [params.name] - Filter by name
 * @param {string} [params.ordering] - Field to order by
 * @param {number} [params.page] - Page number
 * @param {number} [params.page_size] - Results per page
 * @param {number} [params.price] - Filter by price
 * @returns {Promise<import('axios').AxiosResponse>} List of premium backlinks
 */
export const premiumBacklinksBacklinksList = async (params = {}) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/`, { params });
  
  return response;
};

export const premiumBacklinksBacklinksCreate = async (backlinkData) => {
  const response = await axios
    .post(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/`, backlinkData);
  
  return response;
};

export const premiumBacklinksBacklinksRetrieve = async (id) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/${id}/`);
  
  return response;
};

export const premiumBacklinksBacklinksUpdate = async (id, backlinkData) => {
  const response = await axios
    .put(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/${id}/`, backlinkData);
  
  return response;
};

export const premiumBacklinksBacklinksPartialUpdate = async (id, backlinkData) => {
  const response = await axios
    .patch(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/${id}/`, backlinkData);
  
  return response;
};

export const premiumBacklinksBacklinksDestroy = async (id) => {
  const response = await axios
    .delete(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/${id}/`);
  
  return response;
};

export const premiumBacklinksBacklinksExportCsvRetrieve = async () => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/export-csv/`, {
      responseType: 'blob'
    });
  
  return response;
};

export const premiumBacklinksBacklinksImportCsvCreate = async (csvFile) => {
  const formData = new FormData();
  formData.append('csv_file', csvFile);

  const response = await axios
    .post(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/backlinks/import-csv/`, formData, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
  
  return response;
};

export const premiumBacklinksClientProfilesList = async () => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/client-profiles/`);
  
  return response;
};

export const premiumBacklinksClientProfilesRetrieve = async (clientId) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/client-profiles/${clientId}/`);
  
  return response;
};

/**
 * List premium backlink orders with optional filters
 * @param {Object} params - Query parameters
 * @param {string} [params.client__domain] - Filter by client domain
 * @param {string} [params.ordering] - Field to order by
 * @param {number} [params.page] - Page number
 * @param {number} [params.page_size] - Results per page
 * @param {string} [params.status] - Filter by status
 * @returns {Promise<import('axios').AxiosResponse>} List of orders
 */
export const premiumBacklinksOrdersList = async (params = {}) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/`, { params });
  
  return response;
};

export const premiumBacklinksOrdersCreate = async (orderData) => {
  const response = await axios
    .post(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/`, orderData);
  
  return response;
};

export const premiumBacklinksOrdersRetrieve = async (id) => {
  const response = await axios
    .get(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/${id}/`);
  
  return response;
};

export const premiumBacklinksOrdersUpdate = async (id, orderData) => {
  const response = await axios
    .put(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/${id}/`, orderData);
  
  return response;
};

export const premiumBacklinksOrdersPartialUpdate = async (id, orderData) => {
  const response = await axios
    .patch(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/${id}/`, orderData);
  
  return response;
};

export const premiumBacklinksOrdersDestroy = async (id) => {
  const response = await axios
    .delete(`${REACT_APP_FLASK_API_URL}/dash2-proxy/premium-backlinks/orders/${id}/`);
  
  return response;
};

/**
 * Update a regular backlink using PATCH
 * @param {string} id - Backlink UUID
 * @param {Object} backlinkData - Data to update
 * @returns {Promise<import('axios').AxiosResponse>} Updated backlink
 */
export const backlinksPartialUpdate = async (id, backlinkData) => {
  const response = await axios
    .patch(`${REACT_APP_FLASK_API_URL}/dash2-proxy/backlinks/${id}/`, backlinkData);
  
  return response;
}; 